import { gql } from "gql";

export const AI_MANIPULATE_TEXT_SUBSCRIPTION = gql(/* Graphql */ `
  subscription AiManipulateText ($text:String!, $type: ManipulationType!) {
    aiManipulateText (text:$text, type:$type) {
      ... on ChangeStageAiChatMessage {
        __typename
        stage
        stageId
      }

      ... on UpdateMessageAiChatMessage {
        __typename
        text
        stageId
      }
    }
  }
`);
